import { supabase } from '../lib/supabase';
import type { SugestaoPlaylist, StatusSugestao } from '../models/sugestao.model';

export const sugestaoService = {
  async enviarSugestao(
    empresaId: string,
    telaId: string,
    videoId: string,
    titulo: string,
    thumbnail: string,
    canal: string,
    duracaoSegundos: number | null,
    sessionId?: string,
    clienteId?: string | null,
  ): Promise<void> {
    // Sem .select() de propósito: anon não tem policy de SELECT em
    // sugestoes_playlist (só staff autenticado da própria empresa lê),
    // e um RETURNING/.select() exigiria essa policy também para o INSERT
    // (Postgres precisa da policy de SELECT para devolver a linha inserida).
    const { error } = await supabase
      .from('sugestoes_playlist' as never)
      .insert({
        empresa_id: empresaId,
        tela_id: telaId,
        video_id: videoId,
        titulo,
        thumbnail,
        canal,
        duracao_segundos: duracaoSegundos,
        status: 'pendente',
        ...(sessionId ? { session_id: sessionId } : {}),
        ...(clienteId ? { cliente_id: clienteId } : {}),
      } as never);

    if (error) throw error;
  },

  async listarPendentesPorEmpresa(empresaId: string): Promise<SugestaoPlaylist[]> {
    const { data, error } = await supabase
      .from('sugestoes_playlist')
      .select('*')
      .eq('status', 'pendente')
      .eq('empresa_id', empresaId)
      .order('criado_em', { ascending: false });

    if (error) throw error;
    return (data ?? []) as SugestaoPlaylist[];
  },

  async atualizarStatusSugestao(empresaId: string, id: string, status: StatusSugestao): Promise<void> {
    const { error } = await supabase
      .from('sugestoes_playlist' as never)
      .update({ status } as never)
      .eq('empresa_id', empresaId)
      .eq('id', id);

    if (error) throw error;
  },

  async buscarPorId(empresaId: string, id: string): Promise<SugestaoPlaylist | null> {
    const { data, error } = await supabase
      .from('sugestoes_playlist')
      .select('*')
      .eq('empresa_id', empresaId)
      .eq('id', id)
      .single();

    if (error) {
      if (error.code === 'PGRST116') return null;
      throw error;
    }
    return data as SugestaoPlaylist;
  },

  async verificarDuplicada(empresaId: string, telaId: string, videoId: string): Promise<boolean> {
    // RPC em vez de SELECT direto: anon não tem policy de leitura em
    // sugestoes_playlist (evita reabrir acesso amplo a sugestões de
    // outros tenants) — a RPC só devolve um boolean.
    const { data, error } = await supabase.rpc('sugestao_ja_existe' as never, {
      p_empresa_id: empresaId,
      p_tela_id: telaId,
      p_video_id: videoId,
    } as never);

    if (error) throw error;
    return data === true;
  },
};
